import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var sizings = {
  small: {
    height: 56,
    fontSize: 16,
    label: {
      activeFontSize: 12,

      /**
       * Adjusts the position of the label vertically
       */
      activeTop: 8,
      inactiveTop: 20
    }
  },
  normal: {
    height: 60,
    fontSize: 18,
    label: {
      activeFontSize: 12,

      /**
       * Adjusts the position of the label vertically
       */
      activeTop: 10,
      inactiveTop: 20
    }
  }
};
var inputFieldThemeNative = {
  color: 'primary',
  font: {
    color: 'text'
  },
  borderStyle: 'full',

  /**
   * Passed directly right side Icon as props
   */
  inputIconStyle: {
    size: 24,
    alignItems: 'center',
    color: colors.fogGrey,

    /**
     * Passed as color prop is disabled
     */
    disabled: colors.octoberGrey
  },

  /**
   * Passed directly as style prop to right side iconButton (wraps the icon)
   */
  iconButtonStyle: {
    marginHorizontal: 10,
    borderColor: 'transparent',
    backgroundColor: 'transparent'
  },
  errorColor: 'alert',
  backgroundColor: 'background',
  placeholderColor: colors.fogGrey,
  disabled: {
    border: {
      color: colors.fogGrey
    },
    label: {
      color: colors.fogGrey
    },
    backgroundColor: colors.lightGrey
  },
  readOnly: {
    border: {
      color: 'transparent'
    },
    label: {
      color: colors.fogGrey
    }
  },
  inactive: {
    border: {
      color: colors.fogGrey
    },
    label: {
      color: 'text'
    },
    hasValueColor: colors.octoberGrey
  },
  sizings: sizings
};

var inputFieldDarkThemeNative = _extends({}, inputFieldThemeNative, {
  placeholderColor: colors.octoberGrey,
  color: colors.cloudGrey,
  disabled: {
    border: {
      color: colors.octoberGrey
    },
    label: {
      color: colors.octoberGrey
    },
    backgroundColor: colors.mineShaftGrey
  },
  inactive: {
    border: {
      color: colors.octoberGrey
    },
    label: {
      color: 'text'
    },
    hasValueColor: colors.fogGrey
  }
});

var inputFieldThemeWeb = {
  color: 'primary',
  background: 'background',
  error: 'alert',
  textColor: 'text',
  borderStyle: 'full',
  inactive: colors.fogGrey,
  icons: {
    rightIconSize: 32,
    leftIconSize: 32
  },
  label: {
    color: colors.octoberGrey,
    fontWeight: 400
  },
  disabled: {
    background: colors.lightGrey,
    label: colors.fogGrey
  },
  paddings: {
    input: {
      /**
       * Affects input position when text is entered or field is active
       */
      top: 28,

      /**
       * Affects input position when text is entered or field is active
       */
      bottom: 11
    },
    label: {
      /**
       * Affects label vertical position
       */
      top: 0,

      /**
       * Affects label vertical position
       */
      bottom: 0
    }
  }
};
export { inputFieldDarkThemeNative, inputFieldThemeNative, inputFieldThemeWeb, sizings };